import { call, put } from 'redux-saga/effects';
import {
  loaderDisplayChanged,
  previewFileOpened,
} from 'features/content-library/contentLibrarySlice';
import { signalingContentLibraryFileOpened } from 'features/content-library/actions';
import {
  type InitContentWhiteboardData,
  initContentWhiteboardDataSaga,
} from 'features/content-whiteboard/sagas/initContentWhiteboardDataSaga';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';

export function* previewContentFileSaga(
  action: ReturnType<typeof signalingContentLibraryFileOpened>
) {
  const { id, page, name, whiteboardShapes: shapes = [] } = action.payload.data;

  yield put(loaderDisplayChanged(true));
  yield call(contentBoard.clean);

  yield put(previewFileOpened(action.payload.data));

  const data: InitContentWhiteboardData = { id, page, name, shapes };

  yield call(initContentWhiteboardDataSaga, data, { readOnly: true });
}
